import { BadgePDPModel } from '@sosocio/creator/interfaces';
import ApiService from 'services/ApiService';

class BadgePDPService extends ApiService<BadgePDPModel> {
	constructor() {
		super('badgepdp');
	}
}

export default new BadgePDPService();
